module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love ")]), _c('span', {
    staticClass: "t1"
  }, [_c('br')]), _c('span', {
    staticClass: "t2"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("OHN")]), _c('span', {
    staticClass: "t2"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("IMPSON")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Badges")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("“If you enjoy M/M relationships, this is a very well written book and I recommend it highly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "t0"
  }, [_vm._v("The Romance Studio")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“…an entertaining read where all of the characters are engaging and likable”")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("—Blackraven Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("The Beach House")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“John Simpson tells a touching story of two men damaged by loss trying to go on with their lives.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Sensual Reads")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Alex and Clayton")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I’d give this a definite A for good clean storytelling, characters that I liked and appreciated without casting judgment on their pasts"), _c('span', {
    staticClass: "t6"
  }, [_vm._v(" and")]), _vm._v(" for keeping it basically between the relationship of Alex and Clayton as the title suggests.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—MM Good Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Naval Maneuvers")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("“…a refreshing and honest view of military life and the problems gay men may face is intriguing and enthralling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "t0"
  }, [_vm._v("Manic Readers")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Condor One")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("“…a brilliant story of ‘what if’ and one I highly recommend.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "t0"
  }, [_vm._v("Literary Nymphs")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("“If you like books with thrill-a-minute plots, stories about political wrangling, and tales with sexy men falling in love, then may I suggest you look no further than John Simpson and Condor One. What a rush!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "t0"
  }, [_vm._v("Dark Divas Recommended Read")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Talons of the Condor")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("“…a definite page-turner.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "t0"
  }, [_vm._v("Night Owl Reviews Top Pick")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Out of the Gilded Cage")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("“This is definitely a read now book.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t0"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "t0"
  }, [_vm._v("MM Good Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Irish Winter")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("“This is a story that will stay with me because the essence of the times is captured and haunts me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("—TwoLips Reviews")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac69130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002.vue
// module id = 57
// module chunks = 0